export default __webpack_public_path__ + "static/sneakers3.inspirations-383d141fec8464f86a8f2c84b952f796.jpg";